import { c as _c } from "react/compiler-runtime";
import { Compass } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";
export function ExploreServicesCard(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Compass className="w-full h-full" strokeWidth={1.5} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <PromotionalCardBase icon={t1} title="Discover Our Services" description={"From property search to legal verification & loans \u2014 we've got you covered"} ctaText="Explore Services" href="/services" className={className} iconColor="text-teal-600" />;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}